/*
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
*/

export default class Units {
    constructor() {
        this.units = [];
    }

    get all() {
        return this.units;
    }

    setUnits(units) {
        this.units = [];
        units.forEach(unit => {
            this.units.push(unit)
        });
    }

    addUnits(units) {
        this.units.push(units)
    }

    fromId(id) {
        return this.units.find(unit => unit.conversionId == id)
    }
}